/* eslint-disable no-console */
import { Languages } from '../interfaces/common'
import { IWidgetLoaderConnectParams } from '../interfaces/IWidgetLoaderParams'

function getOnLoadLoaderScript(language: Languages, onSuccess: () => void) {
  return () => {
    ;(window as any).WidgetLoader.setLanguage(language)
    onSuccess()
  }
}

function onError() {
  console.error('Widget Loader не загрузился')
}

function getConnectFallbackLoader(params: IWidgetLoaderConnectParams, onSuccess: () => void) {
  let host: string

  switch (params.lang) {
    case Languages.UZ:
      host = 'https://s3.mcfr.uz'
      break
    case Languages.KZ:
      host = 'https://s3.mcfr.kz'
      break
    default:
      host = 'https://s3.action-media.ru'
  }

  return () => {
    const script = document.createElement('script')

    script.async = true
    script.src = params.env === 'prod' ? `${host}/widgets/loader.js` : `${host}/widgets/${params.env}/loader.js`
    script.onload = getOnLoadLoaderScript(params.lang as Languages, onSuccess)
    script.onerror = onError

    document.getElementsByTagName('head')[0].appendChild(script)
  }
}

export function loadWidgetLoader(params: IWidgetLoaderConnectParams, onSuccess: () => void): void {
  const script = document.createElement('script')

  script.async = true
  script.src = 'assets/static/loader.js'
  script.onload = getOnLoadLoaderScript(params.lang as Languages, onSuccess)
  script.onerror = getConnectFallbackLoader(params, onSuccess)

  document.getElementsByTagName('head')[0].appendChild(script)
}
